(function (global) {
  "use strict";

  var drawer;
  var panel;
  var itemsRoot;
  var subtotalNode;
  var clearButton;
  var viewCartLink;
  var toggleButtons;
  var currencyCode = "USD";
  var isOpen = false;
  var isBusy = false;
  var busyLines = {};
  var REMOVE_FADE_MS = 280;
  var QTY_DEBOUNCE_MS = 200;

  function getNodes() {
    drawer = document.querySelector("[data-cart-drawer]");
    panel = document.querySelector("[data-cart-panel]");
    itemsRoot = document.querySelector("[data-cart-items]");
    subtotalNode = document.querySelector("[data-cart-subtotal]");
    clearButton = document.querySelector("[data-cart-clear]");
    viewCartLink = document.querySelector("[data-cart-view-link]");
    toggleButtons = document.querySelectorAll("[data-cart-toggle]");
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: "currency",
      currency: currencyCode,
    });
  }

  function escapeAttr(value) {
    return String(value).replace(/"/g, "&quot;");
  }

  function buildRemoveButton(line, title) {
    var label = title ? "Remove " + title : "Remove item";
    return (
      '<button type="button" class="cart-drawer-remove shrink-0 self-start rounded-lg border-[2px] border-[var(--border-struct)] bg-[#FF4136] px-2.5 py-1.5 text-[10px] font-black uppercase leading-none text-white shadow-[var(--shadow-hard-sm)] transition-transform hover:-translate-y-0.5 disabled:opacity-50" data-cart-remove data-line="' +
      line +
      '" aria-label="' +
      escapeAttr(label) +
      '">✕</button>'
    );
  }

  function buildQtyButton(action, line, title) {
    var isDecrease = action === "decrease";
    var dataAttr = isDecrease ? "data-cart-qty-decrease" : "data-cart-qty-increase";
    var label =
      (isDecrease ? "Decrease" : "Increase") +
      " quantity" +
      (title ? " of " + title : "");
    var icon = isDecrease
      ? '<path d="M3 8h10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"></path>'
      : '<path d="M8 3v10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"></path><path d="M3 8h10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"></path>';

    return (
      '<button type="button" class="cart-drawer-qty-btn" ' +
      dataAttr +
      ' data-line="' +
      line +
      '" aria-label="' +
      escapeAttr(label) +
      '">' +
      '<span class="cart-drawer-qty-btn__dial">' +
      '<svg class="cart-drawer-qty-btn__icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">' +
      icon +
      "</svg>" +
      "</span>" +
      '<span class="cart-drawer-qty-btn__spark" aria-hidden="true"></span>' +
      "</button>"
    );
  }

  function buildQuantityControls(line, quantity, title) {
    return (
      '<div class="cart-drawer-qty" data-cart-qty data-line="' +
      line +
      '">' +
      buildQtyButton("decrease", line, title) +
      '<span class="cart-drawer-qty-value" data-cart-qty-value aria-live="polite">' +
      quantity +
      "</span>" +
      buildQtyButton("increase", line, title) +
      "</div>"
    );
  }

  function triggerQtyButtonClick(button) {
    if (!button || button.disabled) return;

    button.classList.remove("cart-drawer-qty-btn--click");
    void button.offsetWidth;
    button.classList.add("cart-drawer-qty-btn--click");

    window.setTimeout(function () {
      button.classList.remove("cart-drawer-qty-btn--click");
    }, 360);
  }

  function renderItems(cart) {
    if (!itemsRoot) return;

    if (!cart.items.length) {
      itemsRoot.innerHTML =
        '<p class="rounded-2xl border border-dashed border-[var(--border-struct)]/25 px-4 py-8 text-center font-mono text-xs uppercase tracking-widest text-[var(--text-muted)]">Your cart is empty.</p>';
      return;
    }

    itemsRoot.innerHTML =
      '<ul class="cart-drawer-list space-y-4" data-cart-list>' +
      cart.items
        .map(function (item, index) {
          var line = index + 1;
          var variant =
            item.variant_title && item.variant_title !== "Default Title"
              ? '<p class="mt-1 text-xs text-[var(--text-muted)]">' +
                item.variant_title +
                "</p>"
              : "";
          var image = item.image
            ? '<img src="' +
              item.image +
              '" alt="" class="h-16 w-16 shrink-0 rounded-lg border border-[var(--border-accent)] object-cover" loading="lazy">'
            : "";

          return (
            '<li class="cart-drawer-item flex gap-3 rounded-2xl border-[2px] border-[var(--border-struct)] bg-[var(--bg-card-glass)] p-3 shadow-[var(--shadow-hard-sm)]" data-cart-line="' +
            line +
            '">' +
            image +
            '<div class="min-w-0 flex-1">' +
            '<p class="truncate text-sm font-black uppercase text-[var(--text-main)]">' +
            item.product_title +
            "</p>" +
            variant +
            '<div class="mt-2 flex flex-wrap items-center justify-between gap-2">' +
            '<p class="text-sm font-bold text-[var(--text-main)]" data-cart-line-price>' +
            formatMoney(item.final_line_price) +
            "</p>" +
            buildQuantityControls(line, item.quantity, item.product_title) +
            "</div>" +
            "</div>" +
            buildRemoveButton(line, item.product_title) +
            "</li>"
          );
        })
        .join("") +
      "</ul>";
  }

  function updateFooterActions(cart) {
    var hasItems = cart.item_count > 0;
    if (clearButton) clearButton.hidden = !hasItems;
    if (viewCartLink) viewCartLink.hidden = !hasItems;
  }

  function publishCartUpdate(cart) {
    syncCartUI(cart);
    document.dispatchEvent(
      new CustomEvent("p4p:cart:updated", { detail: cart }),
    );
  }

  function syncCartUI(cart) {
    if (!cart) return;

    if (cart.currency) currencyCode = cart.currency;

    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = cart.item_count;
    });

    if (subtotalNode) {
      subtotalNode.textContent = formatMoney(cart.total_price);
    }

    renderItems(cart);
    updateFooterActions(cart);
  }

  function fetchCart() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to load cart.");
      return response.json();
    });
  }

  function fetchAndSyncCart() {
    return fetchCart().then(function (cart) {
      publishCartUpdate(cart);
      return cart;
    });
  }

  function changeLineQuantity(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ line: Number(line), quantity: quantity }),
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (errorBody) {
          throw new Error(errorBody.description || "Unable to update cart.");
        });
      }
      return response.json();
    });
  }

  function clearCartRequest() {
    return fetch("/cart/clear.js", {
      method: "POST",
      headers: { Accept: "application/json" },
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (errorBody) {
          throw new Error(errorBody.description || "Unable to clear cart.");
        });
      }
      return response.json();
    });
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function getLineRow(line) {
    if (!itemsRoot) return null;
    return itemsRoot.querySelector('[data-cart-line="' + line + '"]');
  }

  function setLineBusy(line, busy) {
    var row = getLineRow(line);
    if (!row) return;

    row.classList.toggle("cart-drawer-item--updating", busy);
    row.querySelectorAll(
      "[data-cart-qty-decrease], [data-cart-qty-increase]",
    ).forEach(function (button) {
      button.disabled = busy;
    });
  }

  function getLineQuantity(line) {
    var row = getLineRow(line);
    if (!row) return 1;

    var qtyNode = row.querySelector("[data-cart-qty-value]");
    if (!qtyNode) return 1;

    var parsed = parseInt(qtyNode.textContent, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  }

  function adjustLineQuantity(line, delta) {
    if (busyLines[line]) return Promise.resolve();

    var currentQty = getLineQuantity(line);
    var newQty = currentQty + delta;

    if (newQty <= 0) {
      return removeLineItem(line);
    }

    busyLines[line] = true;
    setLineBusy(line, true);

    var startedAt = Date.now();

    return changeLineQuantity(line, newQty)
      .then(function (cart) {
        var elapsed = Date.now() - startedAt;
        return wait(Math.max(0, QTY_DEBOUNCE_MS - elapsed)).then(function () {
          return cart;
        });
      })
      .then(function (cart) {
        publishCartUpdate(cart);
        return cart;
      })
      .catch(function (error) {
        window.alert(error.message || "Unable to update quantity.");
      })
      .finally(function () {
        delete busyLines[line];
        setLineBusy(line, false);
      });
  }

  function removeLineItem(line) {
    if (isBusy || !itemsRoot) return Promise.resolve();

    var row = getLineRow(line);
    if (!row) return Promise.resolve();

    isBusy = true;
    row.classList.add("cart-drawer-item--removing");

    var removeButton = row.querySelector("[data-cart-remove]");
    if (removeButton) removeButton.disabled = true;
    setLineBusy(line, true);

    return wait(REMOVE_FADE_MS)
      .then(function () {
        return changeLineQuantity(line, 0);
      })
      .then(function (cart) {
        publishCartUpdate(cart);
        return cart;
      })
      .catch(function (error) {
        row.classList.remove("cart-drawer-item--removing");
        if (removeButton) removeButton.disabled = false;
        setLineBusy(line, false);
        window.alert(error.message || "Unable to remove item.");
      })
      .finally(function () {
        isBusy = false;
        delete busyLines[line];
      });
  }

  function clearEntireCart() {
    if (isBusy) return Promise.resolve();

    var list = itemsRoot && itemsRoot.querySelector("[data-cart-list]");
    if (list) {
      list.classList.add("cart-drawer-list--clearing");
      list.querySelectorAll(".cart-drawer-item").forEach(function (row) {
        row.classList.add("cart-drawer-item--removing");
      });
    }

    if (clearButton) clearButton.disabled = true;

    isBusy = true;

    return wait(REMOVE_FADE_MS)
      .then(clearCartRequest)
      .then(function (cart) {
        publishCartUpdate(cart);
        return cart;
      })
      .catch(function (error) {
        if (list) list.classList.remove("cart-drawer-list--clearing");
        window.alert(error.message || "Unable to clear cart.");
      })
      .finally(function () {
        isBusy = false;
        if (clearButton) clearButton.disabled = false;
      });
  }

  function setToggleExpanded(expanded) {
    toggleButtons.forEach(function (button) {
      button.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  }

  function openDrawer() {
    if (!drawer || !panel) return;

    if (!isOpen) {
      isOpen = true;
      drawer.classList.remove("pointer-events-none", "opacity-0");
      drawer.classList.add("opacity-100");
      drawer.setAttribute("aria-hidden", "false");
      panel.classList.remove("translate-x-full");
      panel.classList.add("translate-x-0");
      setToggleExpanded(true);
      document.body.style.overflow = "hidden";
    }

    fetchAndSyncCart().catch(function () {});
  }

  function closeDrawer() {
    if (!drawer || !panel || !isOpen) return;

    isOpen = false;
    drawer.classList.add("pointer-events-none", "opacity-0");
    drawer.classList.remove("opacity-100");
    drawer.setAttribute("aria-hidden", "true");
    panel.classList.add("translate-x-full");
    panel.classList.remove("translate-x-0");
    setToggleExpanded(false);
    document.body.style.overflow = "";
  }

  function bindEvents() {
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-cart-toggle]")) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (event.target.closest("[data-cart-close]")) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var decreaseButton = event.target.closest("[data-cart-qty-decrease]");
      if (decreaseButton) {
        event.preventDefault();
        triggerQtyButtonClick(decreaseButton);
        var decreaseLine = decreaseButton.getAttribute("data-line");
        if (decreaseLine) adjustLineQuantity(decreaseLine, -1);
        return;
      }

      var increaseButton = event.target.closest("[data-cart-qty-increase]");
      if (increaseButton) {
        event.preventDefault();
        triggerQtyButtonClick(increaseButton);
        var increaseLine = increaseButton.getAttribute("data-line");
        if (increaseLine) adjustLineQuantity(increaseLine, 1);
        return;
      }

      var removeButton = event.target.closest("[data-cart-remove]");
      if (removeButton) {
        event.preventDefault();
        var line = removeButton.getAttribute("data-line");
        if (line) removeLineItem(line);
        return;
      }

      if (event.target.closest("[data-cart-clear]")) {
        event.preventDefault();
        clearEntireCart();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen) closeDrawer();
    });

    document.addEventListener("cart:open", openDrawer);
    document.addEventListener("p4p:cart:open", openDrawer);

    document.addEventListener("p4p:cart:updated", function (event) {
      if (event.detail) syncCartUI(event.detail);
    });
  }

  function init() {
    getNodes();
    if (!drawer || !panel) return;

    var metaCurrency = document.querySelector("[data-shop-currency]");
    if (metaCurrency) {
      currencyCode =
        metaCurrency.getAttribute("data-shop-currency") || currencyCode;
    }

    bindEvents();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  global.P4PCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    sync: syncCartUI,
    removeLine: removeLineItem,
    clear: clearEntireCart,
    adjustQuantity: adjustLineQuantity,
  };
})(typeof window !== "undefined" ? window : this);
